export var GET_PUBLISHER_INIT = 'GET_PUBLISHER_INIT';
export var GET_PUBLISHER_SUCCESS = 'GET_PUBLISHER_SUCCESS';
export var GET_PUBLISHER_ERROR = 'GET_PUBLISHER_ERROR';
export var GET_PUBLISHER_DONE = 'GET_PUBLISHER_DONE';
export var GET_PUBLISHER_REVENUE_INIT = 'GET_PUBLISHER_REVENUE_INIT';
export var GET_PUBLISHER_REVENUE_SUCCESS = 'GET_PUBLISHER_REVENUE_SUCCESS';
export var GET_PUBLISHER_REVENUE_ERROR = 'GET_PUBLISHER_REVENUE_ERROR';
export var GET_PUBLISHER_REVENUE_DONE = 'GET_PUBLISHER_REVENUE_DONE';
export var PUBLISHER_DISPLAY_LAYOUT = 'PUBLISHER_DISPLAY_LAYOUT';
export var STORE_PUBLISHERS_REPORT_SUCCESS = 'STORE_PUBLISHERS_REPORT_SUCCESS';
export var UPDATE_DEFAULT_SETTING_INIT = 'UPDATE_DEFAULT_SETTING_INIT';
export var UPDATE_DEFAULT_SETTING_SUCCESS = 'UPDATE_DEFAULT_SETTING_SUCCESS';
export var UPDATE_DEFAULT_SETTING_ERROR = 'UPDATE_DEFAULT_SETTING_ERROR';
export var UPDATE_DEFAULT_SETTING_STATUS = 'UPDATE_DEFAULT_SETTING_STATUS';
